import type { TrackingEvent, FacebookEventInfo } from '../types/tracking.types';
import { getFacebookBrowserParameter, calculateNumItems } from '../utils/tracking.utils';

/**
 * Mapeamento de eventos para Facebook Pixel
 * Nota: add_shipping_info vira AddPaymentInfo, add_payment_info não é enviado para evitar duplicação
 */
const FB_EVENT_MAPPING: Record<string, string> = {
  'begin_checkout': 'InitiateCheckout',
  'add_shipping_info': '', // Meta não tem evento padrão para endereço — omitido
  'add_payment_info': 'AddPaymentInfo', // dispara ao abrir a seção de pagamento
  'purchase': 'Purchase',
  'page_view': 'PageView'
};

/**
 * Envia evento para Facebook Pixel
 */
export const sendToFacebook = (pixelId: string, eventName: string, event: TrackingEvent, universalEventId: string): void => {
  if (!pixelId || !window.fbq) {
    return;
  }
  
  try {
    const fbEventName = FB_EVENT_MAPPING[eventName] ?? eventName;
    
    // Se o mapeamento retornar string vazia, não envia para o Facebook
    if (!fbEventName) {
      return;
    }
    
    // Obter fbp dos cookies para melhor atribuição
    const fbp = getFacebookBrowserParameter();
    const fbEventInfo: FacebookEventInfo = { 
      eventID: universalEventId,
      ...(fbp && { fbp }) // Adiciona fbp apenas se existir
    };
    
    // Busca dados do Facebook no evento, ou usa dados básicos como fallback
    const baseFbData = (event as any).fb_data || {
      currency: event.ecommerce.currency,
      value: event.ecommerce.value,
      content_type: 'product',
      content_ids: event.ecommerce.items?.map(item => item.item_id) || []
    };
    
    // Adiciona num_items automaticamente se não estiver presente
    const fbData = {
      ...baseFbData,
      num_items: baseFbData.num_items || calculateNumItems(event.ecommerce.items || [])
    };
    
    // multi-pixel safe: envia apenas para o pixel informado
    window.fbq?.('trackSingle', pixelId, fbEventName, fbData, fbEventInfo);
    
  
  } catch (error) {
    console.error(`❌ Facebook: Erro ao enviar evento para ${pixelId}:`, error);
  }
};

/**
 * Envia PageView para Facebook Pixel
 */
export const sendPageViewToFacebook = (pixelId: string, universalEventId: string): void => {
  if (!pixelId || !window.fbq) return;
  
  try {
    // multi-pixel safe: evita PageView duplicado em múltiplos pixels
    window.fbq?.('trackSingle', pixelId, 'PageView', {}, { eventID: universalEventId });
  } catch (error) {
    console.error(`❌ Facebook: Erro ao enviar PageView para ${pixelId}:`, error);
  }
}; 